import { FC } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface CostDetailsProps {
  data: any;
  colors: any;
}

const LineChart: FC<CostDetailsProps> = ({ data, colors }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          {colors.map((item: any, index: number) => (
            <linearGradient
              id={item.name}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
              key={index}
            >
              <stop offset="5%" stopColor={item.accentColor} stopOpacity={1} />
              <stop offset="95%" stopColor={item.accentColor} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>
        <XAxis className="font-semibold text-sm tracking-wide" dataKey="name" style={{fill: '#8F95B2'}} dy={5} />
        <YAxis className="inputoutput font-bold tracking-wide" style={{fill: '#000'}} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        {colors.map((item: any, index: number) => (
          <Area
            key={index}
            type="monotone"
            dataKey={item.name}
            stroke={item.color}
            fillOpacity={1}
            fill={"url(#" + item.name + ")"}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default LineChart;
